export enum PassportStrategiesEnum {
  local = 'local',
  firebase = 'firebase'
}
